import { IFilterTypeOptions } from "./interfaces";

export const filterTypeOptions: IFilterTypeOptions = {
    number: [
        { label: "equals", value: "__exact" },
        { label: "like", value: "__icontains" },
        { label: "lower than", value: "__lt" },
        { label: "lower or equal", value: "__lte" },
        { label: "greater than", value: "__gt" },
        { label: "greater or equal", value: "__gte" },
        { label: "not like", value: "__not_icontains" },
    ],
    date: [
        { label: "range", value: "__range" },
        { label: "equals", value: "__icontains" },
        { label: "lower than", value: "__date__lt" },
        { label: "lower or equal", value: "__date__lte" },
        { label: "greater than", value: "__date__gt" },
        { label: "greater or equal", value: "__date__gte" },
    ],
    text: [
        { label: "equals", value: "__exact" },
        { label: "like", value: "__icontains" },
        { label: "not like", value: "__not_icontains" },
    ],
    dropdown: [
        { label: "equals", value: "__exact" },
        { label: "not equals", value: "__ne" },
    ],
    checkbox: [{ label: "equals", value: "__exact" }],
};

export const checkboxOptions: ILabelValue[] = [
    { label: "Selected", value: "True" },
    { label: "Not selected", value: "False" },
];
